export default "__VITE_ASSET__e47f38cb__"